<template>
  <div class="col-sm-6">
    <div class="panel-btn-container panel panel-default">
      <div class="panel-heading">Click An Input Type To Add To Form</div>
      <div class="panel-body">
        <a href="#" type="button" class="btn btn-default panel-btn" @click.prevent="addToForm('text')">Text Input</a>
        <a href="#" type="button" class="btn btn-default panel-btn" @click.prevent="addToForm('textarea')">Text Area</a>
        <a href="#" type="button" class="btn btn-default panel-btn" @click.prevent="addToForm('select')">Select Dropdown</a>
        <a href="#" type="button" class="btn btn-default panel-btn" @click.prevent="addToForm('radio')">Radio Button</a>
        <a href="#" type="button" class="btn btn-default panel-btn" @click.prevent="addToForm('checkbox')">Checkbox</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideBar',
  methods: {
    addToForm (elementType) {
      this.$bus.emit('add-to-form', elementType)
    }
  }
}
</script>

<style scoped>
.panel-btn {
  margin-bottom: 10px;
  margin-right: 5px;
}
</style>
